var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { PurchaseOrdersMapper } from './purchase-orders.mapper';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-data";
var SupplierPurchaseOrdersRestService = /** @class */ (function (_super) {
    __extends(SupplierPurchaseOrdersRestService, _super);
    function SupplierPurchaseOrdersRestService(settings) {
        var _this = _super.call(this, settings) || this;
        _this.settings = settings;
        return _this;
    }
    SupplierPurchaseOrdersRestService.prototype.findAll = function (showRejected, officeId) {
        return this.createSlicedDataSourceGet("/purchase-orders", {
            officeId: officeId,
            showRejected: showRejected,
        }, void 0, arrayOf(PurchaseOrdersMapper));
    };
    SupplierPurchaseOrdersRestService.prototype.acceptOrder = function (orderId, version) {
        return this.httpGet("/purchase-orders/" + orderId + "/accept?version=" + version, PurchaseOrdersMapper);
    };
    SupplierPurchaseOrdersRestService.prototype.rejectOrder = function (orderId, version) {
        return this.httpGet("/purchase-orders/" + orderId + "/reject?version=" + version, PurchaseOrdersMapper);
    };
    SupplierPurchaseOrdersRestService.ɵfac = function SupplierPurchaseOrdersRestService_Factory(t) { return new (t || SupplierPurchaseOrdersRestService)(i0.ɵɵinject(i1.RestSettings)); };
    SupplierPurchaseOrdersRestService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierPurchaseOrdersRestService, factory: SupplierPurchaseOrdersRestService.ɵfac });
    return SupplierPurchaseOrdersRestService;
}(AbstractRestService));
export { SupplierPurchaseOrdersRestService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierPurchaseOrdersRestService, [{
        type: Injectable
    }], function () { return [{ type: i1.RestSettings }]; }, null); })();
